import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';
import { r as remCalc } from './index5.js';
import { R as RocheModalTrigger } from './roche-modal-trigger.js';
import { d as defineCustomElement$2 } from './roche-icon2.js';

var ModalAppearance;
(function (ModalAppearance) {
    ModalAppearance["DEFAULT"] = "default";
    ModalAppearance["PIPELINE"] = "pipeline";
})(ModalAppearance || (ModalAppearance = {}));

const rocheModalCss = ":host{z-index:350;position:fixed;inset:0;display:flex;flex-direction:column;justify-content:center;align-items:center;opacity:0;pointer-events:none;background:rgba(49, 47, 46, 0.4)}.content-wrapper{background:#fff;filter:drop-shadow(0 0 0.625rem rgba(0, 0, 0, 0.1))}.close{display:flex;justify-content:end;padding:0.75rem}.close roche-icon{cursor:pointer}:host([is-open]){opacity:1;transition:opacity 150ms ease-in;pointer-events:auto}:host([appearance=pipeline]) .content-wrapper{height:100%;width:100%;overflow:auto}";
const RocheModalStyle0 = rocheModalCss;

const RocheModal$1 = /*@__PURE__*/ proxyCustomElement(class RocheModal extends HTMLElement {
    handleRocheModalTrigger() {
        this.isOpen = true;
        DomService.lockBody();
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.isOpen = false;
        this.appearance = ModalAppearance.DEFAULT;
        this.closeModal = this.closeModal.bind(this);
    }
    render() {
        return (h(Host, { key: 'eb42eb1d7543140808401b612a457698ce896e7f', appearance: true }, h("div", { key: 'a813adc2a8f8f622fb77b379e498c28dc133b525', class: 'content-wrapper' }, h("div", { key: 'b9bb5f548aa8cab1b2ced0fe6442db76c2813316', class: "close" }, h("roche-icon", { key: 'cd09f60dd25623d5e15750bd3b6377780690cc26', icon: "mobile-close", height: `${remCalc(32)}rem`, onClick: this.closeModal })), h("slot", { key: 'd0ab467b204ffd0ab21e31645f1243efd2968488' }))));
    }
    closeModal() {
        this.isOpen = false;
        RocheModalTrigger.close();
        DomService.unlockBody();
    }
    static get style() { return RocheModalStyle0; }
}, [1, "roche-modal", {
        "isOpen": [1540, "is-open"],
        "appearance": [513]
    }, [[8, "rocheModalTrigger", "handleRocheModalTrigger"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-modal", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheModal$1);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const RocheModal = RocheModal$1;
const defineCustomElement = defineCustomElement$1;

export { RocheModal, defineCustomElement };

//# sourceMappingURL=roche-modal.js.map